import areaData from './data'

export const getDistrictName = (code , ch = '') => {
  let p = areaData['86'] , ret = []
  let l = [code.substring(0, 2) + '0000' , code.substring(0, 4) + '00' , code]
  for(let i of l){
    if( p ){
      if(p[i]) ret.push( p[i] )
      if(areaData[i]) p = areaData[i]
    }else{
      break
    }
  }
  return ret.join(ch)
}

export const getDistrictCode = (arr) => {
  let p = '86'
  for (let i = 0; i < arr.length; i++) {
    let d = areaData[p]
    if(!d) break
    for (let j in d) {
      if (d[j] === arr[i]) {
        p = j
        break
      }
    }
  }
  return p
}

const levelArr = [0, 1, 2, 3];

const oneOf = (item, arr) => arr.some(i => (i === item))

const getOne = (a) => {
  for (let i in a) {
    return i
  }
}
const getIndex = (list, name) => {
  for (let i in list) {
    if (list[i] === name) {
      return i;
    }
  }
};

const getParent = (code) => {
  for (let i = 1, l = code.length; i < l; i++) {
    let pcode = code.substring(0, l - i)
    if (areaData[pcode]) {
      return pcode;
    }
  }

  return '86'
}

const convValue = (arr) => {
  let i = 0;
  let res = [];
  return arr.map((code, idx) => {
    let name = areaData[idx ? arr[idx - 1] : '86'][code]
    return { code, name }
  })
}

const interest = (a , b) => {
  let prop = String(b).match(/\d{2}/g)

  let props = a.map(i => String(i).match(/\d{2}/g))
  for(let i of props){
    if( 
      i[0] == prop[0] && 
      ( i[1] == prop[1] || i[1] == '00' || prop[1] == '00' ) && 
      ( i[2] == prop[2] || i[2] == '00' || prop[2] == '00' ) 
    ) {
      return true
    }
  }
  return false
}

const contain = (a , b) => {
  let prop = String(b)

  let props = a.map(i => String(i).replace(/0*$/g,''))

  return props.some(i => b.startsWith(i))
}

const gaData = (d, lv = 3, start = 0 , limit = []) => {
  let o = areaData[d]
  let ret = []
  for (let i in o) {
    let item = {
      value: i,
      label: o[i],
      '_index': start
    }
    if (areaData[i] && start < lv - 1) {
      item.children = gaData(i, lv, start + 1,limit)
    }
    if( limit.length == 0 || interest(limit , i) ){
      ret.push(item)
    }
  }
  return ret
}

const parentMap = (o, d, parentId) => {
  for (let i in d) {
    if (parentId != 0) {
      o[i] = parentId
    }
    if (typeof d[i] === 'object') {
      parentMap(o, d[i], i)
    }
  }

  return o
}
const dataType = ['all', 'code', 'name'];

const checkLevel = val => oneOf(val, levelArr)

const hash = parentMap({}, areaData, 0)

const dispatch = (root, componentName, eventName, params) => {
  let parent = root.$parent || root.$root;
  let name = parent.$options.name;
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent;
    if (parent) {
      name = parent.$options.componentName;
    }
  }
  if (parent) {
    parent.$emit(...[eventName].concat(params));
  }
}

export default {
  name: 'Area',
  props: {
    // value: {
    //   type:Array,
    //   default:function(){
    //     return []
    //   }
    // },
    value: {
      type: [Number, String, Array],
      default: ''
    },
    level: {
      type: [Number, String],
      default: 3,
      validator: val => {
        return checkLevel(parseInt(val));
      }
    },
    dataType: {
      type: String,
      default: 'all',
      validator: val => {
        return oneOf(val, dataType);
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    changeOnSelect: {
      type: Boolean,
      default: true
    },
    slient:{
      type: Boolean,
      default: false
    },
    size: String,
    limit:{
      type: Array,
      default(){
        return []
      }
    },
    placeholder: String,
    renderFormat: Function
  },
  data() {
    return {
      data: [],
      currentValue: [],
      lastChange: []
    };
  },
  computed: {
    showLevel() {
      return parseInt(this.level);
    }
  },
  mounted() {
    this.init();
  },
  created() {
    this.$watch('value', function(nv) {
      this.setDefaultValue();
    }, { immediate: true })
  },
  methods: {
    init() {
      this.data = gaData('86', this.level, 0 , this.limit);
    },
    setDefaultValue() {
      if (this.value) {
        let select = [];
        if (isNaN(parseInt(this.value))) {

        } else {
          let pcode = this.value
          while (pcode) {
            if (hash[pcode]) {
              select.unshift(pcode)
              pcode = hash[pcode]
            } else {
              break;
            }
          }
        }
        this.currentValue = select;

        let res = convValue(select);

        if (select.length) {
          if( !this.slient ){
            this.$emit('input', select[select.length - 1]);
            this.$emit('on-change', select[select.length - 1]);
            this.$emit('change', select[select.length - 1]);
            this.$emit('change-data', res);
          }
        }

      } else {
        this.currentValue = []
      }

    },
    handleChange(v) {
      this.currentValue = v
      this.$emit('select', convValue(v));

      //clear
      if (v.length == 0) {
        this.handleClear()
      }
    },

    handleClear() {
      this.$emit('clear')
      this.$emit('input', null);
      this.$emit('on-change', []);
      this.$emit('change', []);
      this.$emit('change-data', []);
      dispatch(this, 'FormItem', 'on-form-change')
    },

    handleVisibleChange(visable) {
      if (!visable) {
        let res = convValue(this.currentValue);
        let value = this.currentValue[this.currentValue.length - 1]
        if(this.limit && this.limit.length  && contain(this.limit , value) == false){
          this.$Message.error('该区域不适用')
          value = null
          res = []
        }

        //if (res.length) {
          this.$emit('input', value);
          this.$emit('on-change', value);
          this.$emit('change', value);
          this.$emit('change-data', res);
          dispatch(this, 'FormItem', 'on-form-change')
        //}
      }
    }
  },
  render() {
    return <Cascader value={this.currentValue} change-on-select={this.changeOnSelect} data={this.data} transfer disabled={this.disabled} size={this.size} placeholder={this.placeholder} render-format={this.renderFormat} on-on-change={this.handleChange} on-on-visible-change={this.handleVisibleChange} scopedSlots={this.$scopedSlots} />
  }
};
